export const zoomForRadiusMiles = (radiusMiles) => {
  if (radiusMiles <= 3) return 13;
  if (radiusMiles <= 5) return 12;
  if (radiusMiles <= 10) return 11;
  if (radiusMiles <= 20) return 11;
  if (radiusMiles <= 35) return 9;
  if (radiusMiles <= 50) return 8;
  return 7;
};

export const MIN_EXPLORE_RADIUS_MILES = 20;

export const capMapZoomToMinRadius = (map, minRadiusMiles = MIN_EXPLORE_RADIUS_MILES) => {
  if (!map || typeof map.getZoom !== 'function' || typeof map.setZoom !== 'function') {
    return;
  }
  const maxZoom = zoomForRadiusMiles(minRadiusMiles);
  const currentZoom = map.getZoom();
  if (currentZoom != null && currentZoom > maxZoom) {
    map.setZoom(maxZoom);
  }
};

export const resizeGoogleMap = (map) => {
  if (!map || !window.google?.maps?.event?.trigger) return;
  const center = typeof map.getCenter === 'function' ? map.getCenter() : null;
  const zoom = typeof map.getZoom === 'function' ? map.getZoom() : null;
  window.google.maps.event.trigger(map, 'resize');
  if (center && typeof map.setCenter === 'function') {
    map.setCenter(center);
  }
  if (zoom != null && typeof map.setZoom === 'function') {
    map.setZoom(zoom);
  }
};

export const bindGoogleMapResize = (map, container) => {
  if (!map || !container) return () => {};

  const resize = () => resizeGoogleMap(map);
  let observer;

  if (typeof ResizeObserver !== 'undefined') {
    observer = new ResizeObserver(resize);
    observer.observe(container);
  }

  resize();

  const idleListener = window.google?.maps?.event?.addListenerOnce?.(map, 'idle', resize);

  return () => {
    observer?.disconnect();
    if (idleListener && window.google?.maps?.event?.removeListener) {
      window.google.maps.event.removeListener(idleListener);
    }
  };
};
